import { IWorkspaceAsset, Service, WorkspaceTemplate } from "@/types/workspace"
import { DiscriminationKey } from "./type"

export const discriminateSpace = (space: WorkspaceTemplate) => {
  const { assets, services } = space.schema
  const deployedAssets = space.schemaDeployed?.assets
  const deployedServices = space.schemaDeployed?.services

  _discriminate(assets, DiscriminationKey.ASSET)
  _discriminate(services, DiscriminationKey.SERVICE)

  if (deployedAssets) {
    _discriminate(deployedAssets, DiscriminationKey.ASSET)
  }
  if (deployedServices) {
    _discriminate(deployedServices, DiscriminationKey.SERVICE)
  }

  return space
}

const _discriminate = (app: IWorkspaceAsset[] | Service[], key: `${DiscriminationKey}`) => {
  app.forEach(item => {
    if (!("_discriminator" in item)) {
      item._discriminator = key as DiscriminationKey
    }
  })
}
